import React from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { Field, Formik } from 'formik';
import FieldWrapper from '../form/wrappers/Field';
import LoaderButton from '../common/LoaderButton';

export default function TerminationDateModal({ show, setShow, onSubmit, data }) {
  const { t } = useTranslation();

  const isMoreThanFiveDaysAgo = (date) => {
    if (!date) return false; // If date is null or undefined, return false
    const selectedDate = new Date(date);
    const currentDate = new Date();
    const fiveDaysAgo = new Date();
    fiveDaysAgo.setDate(currentDate.getDate() - 5);
    return selectedDate < fiveDaysAgo;
  };
  const validationSchema = yup.object().shape({
    termination_date: yup.string().trim().nullable(),
    confirm: yup.string().when('termination_date', {
      is: (termination_date) => isMoreThanFiveDaysAgo(termination_date),
      then: yup
        .string()
        .required(t('common:form:errors:required', { field: 'Confirmation' }))
        .oneOf(['yes'], "You must type 'yes' to proceed"),
      otherwise: yup.string().nullable(),
    }),
  });

  return (
    <Modal
      centered
      backdrop="static"
      show={show}
      onHide={() => setShow(false)}
      aria-labelledby="freeze-app-modal-title"
    >
      <Formik
        initialValues={{
          termination_date: data.termination_date,
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ errors, handleSubmit, isSubmitting, values }) => {
          return (
            <Form noValidate autoComplete="new-password" onSubmit={handleSubmit}>
              <Modal.Header closeButton={!isSubmitting}>
                <Modal.Title as="h3" id="freeze-reasons-modal-title">
                  {t(`admin.applications.detail.terminationDate.modalTitle`)}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Field
                  id="termination_date_field"
                  name="termination_date"
                  type="date"
                  label={<>{t(`admin.applications.detail.terminationDate.label`)}</>}
                  component={FieldWrapper}
                />
                {!isMoreThanFiveDaysAgo(values.termination_date) && (
                  <p className="text-info m-0">
                    {t(`admin.applications.detail.terminationDate.modalMessage`)}
                  </p>
                )}
                {isMoreThanFiveDaysAgo(values.termination_date) && (
                  <>
                    <p className="text-info mb-3 text-danger">
                      {t(`admin.applications.detail.terminationDate.modalWarning`)}
                    </p>
                    <Field
                      id="termination_date_confirmation"
                      name="confirm"
                      type="text"
                      label={<>{t(`admin.applications.detail.terminationDate.confirmation`)}</>}
                      component={FieldWrapper}
                    />
                  </>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="outline-light"
                  onClick={() => setShow(false)}
                  disabled={isSubmitting}
                >
                  {t('common:buttons.cancel')}
                </Button>
                <LoaderButton
                  loading={isSubmitting}
                  onClick={isSubmitting ? (e) => e.preventDefault() : undefined}
                  type="submit"
                  disabled={Object.keys(errors).length}
                >
                  submit
                </LoaderButton>
              </Modal.Footer>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
}
